export default __webpack_public_path__ + "static/media/Ch1c.91c8b6c7.gif";